























































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { AppConstants as _app } from "@/shared/app.constants";

@Component({
    components: {
        DateComponent
    }
})
export default class CommunicationPeriod extends Vue {

    @Prop() readOnly: boolean;
    @Prop() modelWrapper: any;
    @Prop() template: any;
    @Prop() startDate: any;
    @Prop() endDate: any;
    @Prop({ default: [] }) selectedSteps: any;
    @Prop( { default : 1 }) gracePeriod: any; 


    @Action("showNotification", { namespace: 'application' }) notify: any;

    actions = _app.actions;
    subjects = _app.subjects;

    //selectedSteps: any = [];
    comPeriodKey: number = 1;

    comPeriods() {
        if(this.modelWrapper.Steps) {
            return this.modelWrapper.Steps;
        } else {
            this.modelWrapper.Steps = [ {} ];
            return this.modelWrapper.Steps;
        }
    }

    getCommunicationPeriods() {
        this.modelWrapper.Steps = this.$services.agreement.getCommunicationPeriods( 
            this.startDate, 
            this.endDate, 
            this.communicationSteps,
            this.selectedSteps,
            this.gracePeriod
        );
        this.addEmptyRow();
        this.$emit('change');
    }


    addEmptyRow(){
        if(this.modelWrapper.Steps){
            const emptyRow = this.modelWrapper.Steps.find(x => Object.keys(x).length === 0);
            if(!emptyRow) {
                this.modelWrapper.Steps.push({});
                this.comPeriodKey += 1;
            }
        }
        this.$emit('change');
    }

    get communicationSteps() {
        if(this.template) {
            return this.template["x-childSteps"];
        }
    }

    onRemoveRow(index, doc) {
        this.modelWrapper.Steps.splice(index, 1);
        this.addEmptyRow();   
        this.comPeriodKey += 1;
 
    }

    /** validate the start date */
    validateStartDate(doc, val, index) {
        const msg = this.$services.agreement.validateCommunicationStartDate(doc, val, this.startDate, this.endDate )
        if(msg) {
            this.notify(
                {
                    text: msg,
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            doc.StartDate = val;
            this.addEmptyRow(); 
            this.comPeriodKey += 1;
        }   
    }

    /** validate the end date */
    validateEndDate(doc, val, index) {
        const msg = this.$services.agreement.validateCommunicationEndDate(
            doc, 
            val, 
            this.startDate, 
            this.endDate,
            this.gracePeriod )
        if(msg) {
            this.notify(
                {
                    text: msg,
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            doc.EndDate = val;
            this.addEmptyRow(); 
            this.comPeriodKey += 1;
        }   
    }
}

